import * as React from 'react';

import {Channel} from './channel';
import {Entity} from './entity';
import {Product} from './product';
import {RelationshipString} from './relationship-string';
import {Source} from './source';
import {Tokenized} from './tokenized';

function getDisplayComponentForField(fieldName: string) {
    switch (fieldName) {
        case 'creator':
        case 'origin':
        case 'owner':
        case 'territory':
        case 'market':
        case 'industry':
        case 'accountType':
        case 'primaryAccountOwner': {
            return RelationshipString;
        }
        case 'accounts':
        case 'childAccounts':
        case 'parentAccount':
        case 'contacts': {
            return Entity;
        }
        case 'products': {
            return Product;
        }
        case 'sources': {
            return Source;
        }
        case 'channels': {
            return Channel;
        }
        default: {
            return Tokenized;
        }
    }
}

type Props = {
    name: string;
    value: string[] | any;
    isLeadCard?: boolean;
};

export function Relationship(props: Props) {
    const RowComponent = getDisplayComponentForField(props.name);

    return (
        <RowComponent value={props.value} fieldName={props.name} isLeadCard={props.isLeadCard} />
    );
}
